module.exports = __webpack_public_path__ + "static/media/trash.43dd92e9.svg";